/**
 * @generated SignedSource<<7bed5e5c9d1f5de95f09325e6d6db3f0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type designTemplatesQueriesDuplicateTemplatesMutation$variables = {
  destProductsIDs: ReadonlyArray<number>;
  templateIDs: ReadonlyArray<number>;
};
export type designTemplatesQueriesDuplicateTemplatesMutation$data = {
  readonly duplicateTemplates: ReadonlyArray<string>;
};
export type designTemplatesQueriesDuplicateTemplatesMutation = {
  response: designTemplatesQueriesDuplicateTemplatesMutation$data;
  variables: designTemplatesQueriesDuplicateTemplatesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "destProductsIDs"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateIDs"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "destProductsIDs",
        "variableName": "destProductsIDs"
      },
      {
        "kind": "Variable",
        "name": "templateIds",
        "variableName": "templateIDs"
      }
    ],
    "kind": "ScalarField",
    "name": "duplicateTemplates",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "designTemplatesQueriesDuplicateTemplatesMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "designTemplatesQueriesDuplicateTemplatesMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "c802f6c8d32bba29e82df45dbb76557c",
    "id": null,
    "metadata": {},
    "name": "designTemplatesQueriesDuplicateTemplatesMutation",
    "operationKind": "mutation",
    "text": "mutation designTemplatesQueriesDuplicateTemplatesMutation(\n  $destProductsIDs: [Long!]!\n  $templateIDs: [Long!]!\n) {\n  duplicateTemplates(destProductsIDs: $destProductsIDs, templateIds: $templateIDs)\n}\n"
  }
};
})();

(node as any).hash = "a2b27d2263fe7d7ea29fb20692a62b30";

export default node;
